import {
  REACT_APP_AUTH0_AUDIENCE,
  REACT_APP_AUTH0_CLIENTID,
  REACT_APP_AUTH0_DOMAIN,
  REACT_APP_AUTH0_REDIRECTURL,
} from '../utils/envVar';

export const AUTH0_RETURN_TO_KEY = 'auth0ReturnTo';

export const providerConfig: any = {
  domain: REACT_APP_AUTH0_DOMAIN,
  clientId: REACT_APP_AUTH0_CLIENTID,
  authorizationParams: {
    redirect_uri: REACT_APP_AUTH0_REDIRECTURL,
    audience: REACT_APP_AUTH0_AUDIENCE,
  },
  cacheLocation: 'localstorage',
  // Renew tokens via rotating refresh tokens (grant + rotation enabled in the
  // Auth0 dashboard) instead of logging users out when the ID token expires.
  // Fallback keeps iframe silent auth for sessions created before the grant.
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
  // The provider mounts outside the Router, so navigation can't happen here.
  // Stash the deep link for AuthRedirectHandler and strip ?code/?state from
  // the URL (providing a callback replaces the SDK's default cleanup).
  onRedirectCallback: (appState?: { returnTo?: string }) => {
    if (appState?.returnTo) {
      window.sessionStorage.setItem(AUTH0_RETURN_TO_KEY, appState.returnTo);
    }
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
